import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';

@Injectable({
  providedIn: 'root'
})
export class AdministradorService {

  tabla_adilogoRef : any ;// dialo que contiene la tabla de los usuario.
  id_aplicacion : number;
  dialog_crearuser : any; //dialog de creacion de usuario.
  json_usuario : any ;
  
  constructor(private cred_serv : ConsumeCredencialesService,
              private msj_serv : MensajeService,
              private spiner : SpinnerService) { }


  public async crear_administrador(data_form){

    const promesa = this.cred_serv.post('crearUsuario', data_form).toPromise();
    await promesa.then(
      (data : any) =>{

        this.spiner.spin$.next(false);
        let tipo_mensaje = this.msj_serv.TIPO_OK;

        if (data.code >0){
          tipo_mensaje = this.msj_serv.TIPO_ERROR;
        }

        this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje)
            .afterClosed()
            .subscribe(
              ()=>{
                if(data.code == 0){
                  this.dialog_crearuser.close();
                }
              }
              );

      }
    );

  }

  public async acutalizar_usuario(data_form){
    const promesa = this.cred_serv.post('actualizarUsuario', data_form).toPromise();

    await promesa.then(
      (data:any)=>{
        this.spiner.spin$.next(false);
        let tipo_mensaje = this.msj_serv.TIPO_OK;

        if (data.code >0){
          tipo_mensaje = this.msj_serv.TIPO_ERROR;
        }

        this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje)
            .afterClosed()
            .subscribe(
              ()=>{
                if(data.code == 0){
                  this.dialog_crearuser.close();
                }
              }
              );
      }

    );
  }

}
